
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { updateRead } from '@/apis/index';
import { MAGIC_TWO } from '@/config/config';
import Swiper from 'swiper';
import Popup from './Popup.vue';
import { formatName } from '@/utils/tools';
@Component({
  components: {
    Popup,
  },
})
export default class Avatar extends Vue {
  @Prop() private list!: Array<object>;
  @Prop() private swiperIndex!: number;
  @Prop() private length1!: number;
  @Prop() private length2!: number;
  formatName = formatName;
  chooseAvatar = -1;
  author = '';
  id = '';
  itemCard = null;
  industryAvatar = {
    color: '#FF9500',
    background: 'rgba(255,149,0,0.10)',
  };
  mechanismAvatarFont = {
    color: '#FF2436',
  };
  formatStyle() {
    if (this.swiperIndex === 1) {
      return {
        background: 'rgba(255, 36, 54, 0.1) !important',
      };
    } else if (this.swiperIndex === 2) {
      return this.industryAvatar;
    } else {
      return '';
    }
  }
  showRound = false;
  swiper: any = null;
  @Watch('showRound')
  onshowRoundChange(val: boolean) {
    const home = document.getElementsByClassName('home')[0] as HTMLElement;
    if (val) {
      window.sessionStorage.setItem('popShow', '1');
      home.style.overflow = 'hidden';
    } else {
      window.sessionStorage.setItem('popShow', '0');
      home.style.overflow = '';
    }
  }
  changeStatus(index: number) {
    this.$emit('changeStatus', index);
  }
  changeId(item: any) {
    this.id = item.authorId || item.orgId || item.industryId;
  }
  popupShow(name: string, index: any, item: any) {
    window.sessionStorage.setItem('index', index);
    setTimeout(() => {
      this.showRound = true;
    }, 200);
    this.author = name;
    this.itemCard = item;
    this.id = item.authorId || item.orgId || item.industryId;
    //选中的头像是第几个
    if (this.swiperIndex === 1) {
      this.chooseAvatar = this.length1 + index;
    } else if (this.swiperIndex === MAGIC_TWO) {
      this.chooseAvatar = this.length2 + index;
    } else {
      this.chooseAvatar = index;
    }
    if (item.isUpdate) {
      updateRead({
        follow_id: item.industryId || item.orgId || item.authorId,
      }).then(() => {
        item.isUpdate = !item.isUpdate;
        const newList = this.list as any;
        newList[index].isUpdate = 0;
        if (item.industryId) {
          window.sessionStorage.setItem('industry', JSON.stringify(newList));
        } else if (item.orgId) {
          window.sessionStorage.setItem('org', JSON.stringify(newList));
        } else {
          window.sessionStorage.setItem('author', JSON.stringify(newList));
        }
      });
    }
  }
  closePop() {
    this.showRound = false;
  }
  mounted() {
    if (this.swiper) {
      this.swiper.destroy(true, true);
    }
    this.swiper = new Swiper('#avatarCard2', {
      slidesPerView: 'auto',
      normalizeSlideIndex: false,
      observer: true,
      observeParents: true, //修改swiper的父元素时，自动初始化swiper
    });
  }
}
